import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { variables } from '../../styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      cursor: 'pointer',

      '& .MuiOutlinedInput-root': {
        height: 48,
        gap: 12,
        borderRadius: 8,
        padding: '8px 12px',
        backgroundColor: '#FAFAFA',
        fontWeight: 400,
        color: '#030C21',
        cursor: 'pointer',
      },

      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
        cursor: 'pointer',
      },

      '& .MuiOutlinedInput-input': {
        padding: 0,
        cursor: 'pointer',
      },
    },

    '@global': {
      '.MuiPickersDateRangeDay-root .MuiPickersDateRangeDay-rangeIntervalDayHighlightStart .MuiPickersDay-root': {
        backgroundColor: '#030C21 !important',
        borderTopLeftRadius: 10,
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 100,
        paddingTop: 8,
        paddingRight: 16,
        paddingBottom: 8,
        paddingLeft: 16,
      },

      '.MuiPickersCalendar-weekContainer:last-child': {
        marginBottom: '0 !important',
      },

      '.MuiPickersDateRangeDay-dayInsideRangeInterval': {
        color: variables.richBlack,
      },

      '.MuiPickersToolbar-root': {
        backgroundColor: `${variables.mediumSeaGreen} !important`,
      },

      '.MuiPickersModalDialog-dialogAction .MuiButton-textPrimary': {
        color: '#6B7280 !important',
      },

      '.MuiPickersModal-dialogAction .MuiButton-textPrimary': {
        color: '#6B7280 !important',
      },

      '[data-date-range-shortcuts="true"]': {
        position: 'relative',
        zIndex: 2,
        display: 'block',
        width: '100%',
        flexShrink: 0,
        boxSizing: 'border-box',
        visibility: 'visible',
      },

      '[data-date-range-shortcuts-view="desktop"]': {
        marginTop: '-40px !important',
        paddingTop: '0 !important',
      },

      '[data-date-range-shortcuts-view="mobile"]': {
        marginTop: '-6px !important',
        padding: '0 8px !important',
      },

      '.MuiPickersDesktopDateRangeCalendar-root': {
        marginBottom: '0 !important',
        paddingBottom: '0 !important',
      },

      '.MuiPickersDesktopDateRangeCalendar-rangeCalendarContainer': {
        marginBottom: '0 !important',
        paddingBottom: '0 !important',
      },

      '.MuiPickersBasePicker-pickerView': {
        marginBottom: '0 !important',
        paddingBottom: '0 !important',
      },

      '.MuiPickersCalendar-transitionContainer': {
        marginBottom: '0 !important',
      },

      '.MuiDialog-paper [data-date-range-shortcuts="true"]': {
        width: '100%',
      },

      [theme.breakpoints.down('sm')]: {
        '[data-date-range-shortcuts-view="desktop"]': {
          marginTop: '0 !important',
        },

        '[data-date-range-shortcuts-view="mobile"]': {
          marginTop: '-4px !important',
          paddingBottom: '2px !important',
        },
      },
    },
  }),
);
